<template>
    <select class="form-control" :style="qaqcSelectStyling" v-model="fieldData[fieldName]">
        <option selected="true" disabled :value="0">Select</option>
        <option :value="1">Replace</option>
        <option :value="2">Ignore</option>
        <option v-if="hasAppend" :value="3">Append</option>
    </select>
</template>

<script>
import loggingService from '../../services/util/loggingService'

export default {
    name: 'qaqcSelectFormField',
    props: ['fieldData', 'fieldName', 'hasAppend'],
    data: function () {
        return {
            isDebug: false,
            // styling for qaqc Select bg color
            qaqcSelectStyling: {
                backgroundColor: 'rgb(194, 194, 178)',
                maxWidth: '75px'
            }
        }
    },
    mounted () {
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Qaqc Select Form', message)
        }
    }
}
</script>



// WEBPACK FOOTER //
// QaqcFormFieldSelect.vue?326ebd28